import React from "react";
import PropertyForm from "@/pages/PropertyForm";
export default function PropertyEdit() { return <PropertyForm mode="edit" />; }
